import { Form, Formik } from 'formik'
import { FC } from 'react'
import styled from 'styled-components'
import * as Yup from 'yup'

import { t } from 'localization'
import AuthFormField, { FieldType } from 'login/components/AuthFormField'
import { emailValidation } from 'shared/addressValidations'
import { Button } from 'shared/components/Button'
import { Panel } from 'shared/components/Panel'
import { UserAuthQA } from 'shared/dataAttributes'

const TP = 'pages.password.forgotPasswordPanel'

type ForgotPasswordPanelProps = {
  onSubmit(email: string): void
}

const ForgotPasswordPanel: FC<ForgotPasswordPanelProps> = ({ onSubmit }) => {
  const handleSubmit = (values) => {
    const { email } = values
    onSubmit(email)
  }

  const ForgotPasswordSchema = Yup.object({
    email: emailValidation(),
  })

  return (
    <Panel
      qaAttr={UserAuthQA.ForgotPassword}
      subtitle={t(
        `${TP}.pleaseEnter`,
        'Please enter your email address below. You will receive a link to reset your password.',
      )}
      title={t(`${TP}.forgotPassword`, 'Forgot Password?')}
    >
      <Formik
        initialValues={{ email: '' }}
        onSubmit={handleSubmit}
        validationSchema={ForgotPasswordSchema}
      >
        {({ dirty, isValid }) => (
          <Form>
            <AuthFormField
              name="email"
              qaAttr={UserAuthQA.ForgotPasswordEmailBox}
              title={t(`${TP}.emailAddress`, 'Email Address')}
              type={FieldType.Email}
            />
            <FlexColumn>
              <Submit
                buttonType="primary2"
                disabled={!(isValid && dirty)}
                $fill
                qaAttr={UserAuthQA.ForgotPasswordSubmitButton}
                type="submit"
              >
                {t(`${TP}.submit`, 'Submit')}
              </Submit>
              <Button
                as="a"
                buttonType="secondary"
                $fill
                href="/customer/account/login"
                qaAttr={UserAuthQA.ForgotPasswordBackToLoginButton}
              >
                {t(`${TP}.backToLogin`, 'Back to Login')}
              </Button>
            </FlexColumn>
          </Form>
        )}
      </Formik>
    </Panel>
  )
}

const FlexColumn = styled.div`
  display: flex;
  flex-direction: column;
`

const Submit = styled(Button)`
  margin-bottom: 15px;
`

export default ForgotPasswordPanel
